<template>
  <el-drawer
    :visible.sync="visible"
    :close-on-press-escape="false"
    :append-to-body="true"
    :modal-append-to-body="true"
    :with-header="false"
    custom-class="sidebar"
    @close="closeSidebar"
    class="header-sidebar"
  >
    <div class="content">
      <div class="header" @click="action({tag: 'profile'})">
        <div
          v-if="!headUrl"
          class="header-logo-default"
        >
          <i class="toggle-icon icon-outline_personalcenter"></i>
        </div>
        <img
          v-else
          class="header-logo"
          :src="headUrl"
          v-http2
          v-img-size="'medium'"
          v-img-error
        />
        <p class="phone">{{ phone }}</p>
      </div>
      <div class="nav-menu">
        <div
          v-for="(item, i) in quickList"
          :key="i"
          class="nav-menu-item"
          @click="action(item)"
        >
          <i class="menu-icon" :class="item.icon"></i>
          <p class="menu-content">{{ item.content }}</p>
        </div>
      </div>
      <div class="nav-menu nav-menu-footer">
        <div
          v-for="(item, i) in sideList"
          :key="i"
          class="nav-menu-item"
          @click="action(item)"
        >
          <i class="menu-icon" :class="item.icon"></i>
          <p class="menu-content">{{ item.content }}</p>
        </div>
      </div>
      <PersonalFooter
        :bannerMap="bannerMap"
        @action="action"
        @signout="signout"
      />
    </div>
  </el-drawer>
</template>

<script>
import { stopScroll, openScroll } from '@/utils/baseUtil'
import PersonalFooter from '@/components/Header/personalFooter.vue'

export default {
  name: 'my-sidebar',
  components: {
    PersonalFooter
  },
  props: {
    phone: String,
    headUrl: String,
    bannerMap: Object,
    quickList: {
      type: Array,
      default() {
        return []
      }
    },
    sideList: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    action(item) {
      this.closeSidebar()
      this.$emit('action', item.tag, item, true)
    },
    signout() {
      this.$emit('signout')
    },
    showSidebar() {
      this.visible = true;
      stopScroll()
      this.$trackEvent({
        eventId: 'sailing_c_x_sidebar_common_sw',
        eventLabel: '侧边栏展示',
      })
      
    },
    closeSidebar() {
      this.visible = false;
      openScroll()
    },
  },
  destroyed() {
    openScroll()
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>

<style lang="scss">
.header-sidebar {
  .el-drawer {
    width: rem(480) !important;
  }
  .el-drawer__body {
    height: 100%;
  }
  .footer {
    font-size: rem(32);
  }
}
</style>
